import { createCrudHooks } from '../../shared/api/crud-hooks';
import { companiesApi } from './api';
import type { CompanyDto, CompanyInput, CompanyListItem } from './types';

export const companiesHooks = createCrudHooks<CompanyListItem, CompanyDto, CompanyInput>({
  queryKey: ['companies'],
  api: companiesApi,
});
